import { render, staticRenderFns } from "./city-and-guilds.vue?vue&type=template&id=55fe4e17&"
import script from "./city-and-guilds.vue?vue&type=script&lang=js&"
export * from "./city-and-guilds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports